import type { CompoundMarketTemplate, TemplateView } from '@swf/generated/types/api/sports';

export const isCompoundMarketTemplate = (
  template: TemplateView['template']
): template is CompoundMarketTemplate => 'marketIds' in template && 'config' in template;
